import { TypographyOptions } from "@mui/material/styles/createTypography";

export default {
  fontFamily: "Lato",
  allVariants: { color: "#FFFFFF" },
} as TypographyOptions